export function setXinZi (info)
{
    const { SALFROM = '', SALTO = '',  } = info;

    if (!SALFROM && !SALTO) {
        return '未填写';
    }
    // 情况 2: 两个值相等，显示该值
    if (SALFROM === SALTO) {
        return SALFROM;
    }
    
        // 情况 3: 两个值都存在且不相等，显示范围
    if (SALFROM && SALTO && SALFROM !== SALTO) {
        return `${SALFROM}-${SALTO}`;
    }
    
        // 情况 4: SALFROM 为空，SALTO 存在，显示 SALTO 以下
    if ((SALFROM === '' || SALFROM === undefined) && SALTO) {
        return `${SALTO}以下`;
    }
    
        // 情况 5: SALTO 为空，SALFROM 存在，显示 SALFROM 以上
    if ((SALTO === '' || SALTO === undefined) && SALFROM) {
        return `${SALFROM}以上`;
    }
    return "面谈";
}